// src/hooks/useActiveStudy.js
//
// Ticket 13: real implementation backed by SessionContext.
//
// Returns the currently-active study for the currently-active org:
//
//   { studyId, studyName, orgId, loading }  — when session is live
//   { studyId, orgId, loading: false }      — legacy fallback (scripts)
//
// `loading` is true while the session is still resolving the initial
// auth + org + studies chain. Pages that depend on studyId should show
// a spinner while loading is true rather than rendering blank.

import { useSession } from '../auth/sessionContext';

export const LEGACY_DEFAULT_STUDY_ID = 'legacy-default-study';
export const LEGACY_DEFAULT_ORG_ID = 'legacy-default-org';

export function useActiveStudy() {
  const session = useSession();

  const sessionLoading =
    (session && session.loading) || (session && session.studiesLoading) || false;

  if (session && session.activeStudy) {
    return { ...session.activeStudy, loading: sessionLoading };
  }
  if (session && session.activeOrg && !session.activeStudy) {
    return {
      studyId: null,
      orgId: session.activeOrg.orgId,
      loading: sessionLoading,
    };
  }
  return {
    studyId: null,
    orgId: null,
    loading: sessionLoading,
  };
}
